import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  Grid,
  useTheme,
} from "@mui/material";

import Papa from "papaparse";
import Loader from "../../../component/Loader";
import { findFundById, findStrategyById } from "../../../component/Methods";
import { useDispatch, useSelector } from "react-redux";
import { addActiveRequests, updateLoading, updateLoadingMsg } from "../../../Redux/Reducers/uiSlice";
import { sendWebSocketMessage } from "../../../hooks/useWebSocket";
import { selectStrategies, selectFunds } from "../../../Redux/Reducers/selectors";
const CloseTrades = (props) => {
  const { selectedFund, myStrategy, signals, title, openSave, setOpenSave } =
    props;
  const funds = useSelector(selectFunds);
    const strategies = useSelector(selectStrategies);
  const [isMarketData, setIsMarketData] = useState(false);
  const [dataFetching, setDataFetching] = useState(false);
  const dispatch = useDispatch();

  const handleMe = () => {
    setIsMarketData(true);
    setDataFetching(false);

    setTimeout(() => {
      if (!dataFetching) {
        setIsMarketData(false);
      }
    }, 20000);

    const tickersObject = signals.reduce((acc, signal) => {
      if (signal.symbol) {
        acc[signal.symbol] = signal.newValue != null ? signal.newValue : 0;
      }
      return acc;
    }, {});

    sendWebSocketMessage(
      JSON.stringify({
        action: "click_to_trade",
        data: {
          fund: findFundById(selectedFund, funds),
          strategy: findStrategyById(myStrategy, strategies),
          tickers: tickersObject,
        },
      })
    );
    dispatch(addActiveRequests("click_to_trade"));
    dispatch(updateLoading(true));
    dispatch(updateLoadingMsg(""));
    setOpenSave(false);
  };

  const theme = useTheme();
  return (
    <>
      {isMarketData && (
        <>
          <Loader msg={true} marketLoader={false} noMin={true} mTrue={true} />
        </>
      )}
      <Dialog open={openSave} sx={{ width: "100%", height: "100%" }}>
        <DialogTitle>
          <Typography
            variant="h6"
            component="div"
            align="center"
            style={{ flexGrow: 1, fontSize: "20px" }}
          >
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body" component="div" style={{ flexGrow: 1 }}>
            Are you sure you want to save these changes?
          </Typography>
          <Grid
            item
            xs={12}
            margin="20px 1px 20px 1px "
            display="flex"
            justifyContent="space-between"
          >
            <Button
              variant="contained"
              color="success"
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                height: "40px",
                width: "150px",
              }}
              onClick={() => {
                handleMe();
              }}
            >
              SAVE CHANGES
            </Button>
            <Button
              variant="contained"
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                height: "40px",
                width: "150px",
                background: "#B2BEB5",
                color: "#000",
                "&:hover": { background: "#808080" },
              }}
              onClick={() => {
                setOpenSave(false);
              }}
            >
              CANCEL CHANGES
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CloseTrades;